module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification details p-3 w-100 fs-small",
    class: {
      'pointer': _vm.propOptions.markAsReadOnClick,
      'notificationViewed': _vm.notification.markedAsRead == true
    }
  }, [_c('div', [_c('div', {
    staticClass: "titleHolder d-flex flex-row"
  }, [_c('span', {
    staticClass: "d-flex flexGrow1 font-weight-600 align-items-center"
  }, [_c('span', {
    ref: "notificatioTitle",
    staticClass: "notificatioTitle",
    domProps: {
      "innerHTML": _vm._s(_vm.notification.title)
    }
  }), _vm._v(" "), (_vm.notification.metadata && _vm.notification.metadata.labelContent) ? _c('span', {
    staticClass: "notificationTag lightest radius-stadium px-1 py-0 fs-smallest ml-2 text-uppercase",
    class: {
      'bg-color-1': !_vm.notification.metadata.labelColor
    },
    style: ({
      'background-color': _vm.notification.metadata.labelColor
    })
  }, [_vm._v("Pending")]) : _vm._e()]), _vm._v(" "), (!_vm.propOptions.showMarkAsReadDelete) ? _c('div', {
    staticClass: "d-flex justify-content-end pr-1 close-btn",
    on: {
      "click": function($event) {
        return _vm.closeNotification(_vm.notification)
      }
    }
  }, [_vm._v("x")]) : _vm._e(), _vm._v(" "), (_vm.propOptions.showMarkAsReadDelete) ? _c('div', {
    staticClass: "markReadDelete dark d-flex"
  }, [(!_vm.notification.markedAsRead) ? _c('span', {
    staticClass: "markRead pointer radius-normal",
    on: {
      "click": function($event) {
        return _vm.markRead(_vm.notification)
      }
    }
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'Mark as read',
        boundariesElement: 'window'
      }),
      expression: "{content:'Mark as read', boundariesElement:'window'}"
    }],
    staticClass: "far fa-circle fs-small mr-2"
  })]) : _vm._e(), _vm._v(" "), (_vm.notification.markedAsRead) ? _c('span', {
    staticClass: "markRead pointer radius-normal",
    on: {
      "click": function($event) {
        return _vm.markUnread(_vm.notification)
      }
    }
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'Mark as unread',
        boundariesElement: 'window'
      }),
      expression: "{content:'Mark as unread', boundariesElement:'window'}"
    }],
    staticClass: "fas fa-check-circle color-3 fs-small mr-2"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "markRead pointer radius-normal",
    on: {
      "click": function($event) {
        return _vm.markDeleted(_vm.notification, $event)
      }
    }
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'Delete',
        boundariesElement: 'window'
      }),
      expression: "{content:'Delete', boundariesElement:'window'}"
    }],
    staticClass: "far fa-trash-alt fs-small mr-1"
  })])]) : _vm._e()]), _vm._v(" "), (!_vm.showBodyBottom) ? _c(_vm.notificationBodyComponent, {
    tag: "component",
    attrs: {
      "notification": _vm.notification
    },
    on: {
      "markAsRead": function($event) {
        return _vm.markRead(_vm.notification)
      },
      "click:stop": _vm.notificationClicked,
      "clicked": _vm.notificationClicked
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notification.date) ? _c('div', {
    staticClass: "date dark font-weight-600 fs-smaller pt-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.notificationDateTime(_vm.notification)))])]) : _vm._e(), _vm._v(" "), (_vm.showBodyBottom) ? _c(_vm.notificationBodyComponent, {
    tag: "component",
    attrs: {
      "notification": _vm.notification
    },
    on: {
      "markAsRead": function($event) {
        return _vm.markRead(_vm.notification)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notification.metadata && _vm.notification.metadata.id) ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-baseline pr-1 w-100 view-evt"
  }, [_c('div', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.viewEventFromNotification.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "view-event-link"
  }, [_vm._v("View Event")])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.notification.name))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-27b9420c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27b9420c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/notifications/default.vue
// module id = 2451
// module chunks = 0